<main class="main-2-section">
  <div class="event-main">
    <div class="container-fluid">
      <div class="div-header">
        <h1>Upload CSR Project</h1>
      </div>
      <div class="div-contents">
        <form action="" [formGroup]="csruploadForm">
          <div class="row corpate-main-section">
            <div class="col-lg-12 col-md-6 col-sm-12">
              <p class="sub-title">Project Details</p>
            </div>
            <div class="col-lg-8 col-md-6 col-sm-12">
              <div class="form-rows">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    >Name of the Project<span class="text-danger"
                      >*</span
                    ></mat-label
                  >
                  <input
                    matInput
                    placeholder="Enter Project Name "
                    formControlName="projectName"
                    [ngClass]="{
                      'is-invalid':
                        add.projectName.touched && add.projectName.errors
                    }"
                  />
                  <mat-error
                    *ngIf="add.projectName.touched && add.projectName.errors"
                  >
                    <span *ngIf="add.projectName.errors.required"
                      >Project Name is required</span
                    >
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-6 col-12">
              <div class="form-rows">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    >Year of Completion<span class="text-danger"
                      >*</span
                    ></mat-label
                  >
                  <input
                    matInput
                    placeholder="Enter Year of Completion "
                    formControlName="completionYear"
                    maxlength="4"
                    minlength="4"
                    oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                    [ngClass]="{
                      'is-invalid':
                        add.completionYear.touched && add.completionYear.errors
                    }"
                  />
                  <mat-error
                    *ngIf="
                      add.completionYear.touched && add.completionYear.errors
                    "
                  >
                    <span *ngIf="add.completionYear.errors.required"
                      >Year of Completion is required</span
                    >
                    <span *ngIf="add.completionYear.errors.pattern">
                      <i class="fas fa-exclamation-triangle"></i>
                      Year of Completion is Invalid
                    </span>
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12">
              <div class="form-rows">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    >Sector <span class="text-danger">*</span></mat-label
                  >
                  <mat-select
                    formControlName="projectSector"
                    (selectionChange)="change1($event)"
                    [ngClass]="{
                      'is-invalid':
                        add.projectSector.touched && add.projectSector.errors
                    }"
                  >
                    <mat-option
                      *ngFor="let projectSector of allSectors"
                      [value]="projectSector"
                      >{{ projectSector }}</mat-option
                    >
                  </mat-select>
                  <mat-error
                    *ngIf="
                      add.projectSector.touched && add.projectSector.errors
                    "
                  >
                    <span *ngIf="add.projectSector.errors.required"
                      >Sector is required</span
                    >
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12">
              <div class="form-rows">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    >Taluks<span class="text-danger">*</span></mat-label
                  >
                  <input
                    matInput
                    placeholder="Enter Taluks "
                    formControlName="taluks"
                    [ngClass]="{
                      'is-invalid': add.taluks.touched && add.taluks.errors
                    }"
                  />
                  <mat-error *ngIf="add.taluks.touched && add.taluks.errors">
                    <span *ngIf="add.taluks.errors.required"
                      >Taluks is required</span
                    >
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12">
              <div class="form-rows">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    >Interested Districts<span class="text-danger"></span
                  ></mat-label>
                  <mat-select
                    formControlName="districts"
                    multiple
                    (selectionChange)="change($event)"
                    [ngClass]="{
                      'is-invalid':
                        add.districts.touched && add.districts.errors
                    }"
                  >
                    <mat-option
                      *ngFor="let districtlist of districtdataList"
                      [value]="districtlist"
                      >{{ districtlist }}</mat-option
                    >
                  </mat-select>
                  <mat-error
                    *ngIf="add.districts.touched && add.districts.errors"
                  >
                    <span *ngIf="add.districts.errors.required"
                      >Districts is required</span
                    >
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12">
              <div class="form-rows">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    >Budget (INR in Lakhs)<span class="text-danger"
                      >*</span
                    ></mat-label
                  >
                  <input
                    matInput
                    placeholder="Enter Budget"
                    maxlength="7"
                    minlength="6"
                    formControlName="budget"
                    oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                    [ngClass]="{
                      'is-invalid': add.budget.touched && add.budget.errors
                    }"
                  />
                  <mat-error *ngIf="add.budget.touched && add.budget.errors">
                    <span *ngIf="add.budget.errors.required"
                      >Budget is required</span
                    >
                    <span *ngIf="add.budget.errors.pattern">
                      <i class="fas fa-exclamation-triangle"></i>
                      Budget is Invalid
                    </span>
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-8 col-md-6 col-sm-12">
              <div class="form-rows">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    >Project outcome
                    <span class="text-danger">*</span></mat-label
                  >
                  <input
                    matInput
                    placeholder="Enter Project outcome "
                    formControlName="projectOutCome"
                    [ngClass]="{
                      'is-invalid': add.budget.touched && add.budget.errors
                    }"
                  />
                  <mat-error
                    *ngIf="
                      add.projectOutCome.touched && add.projectOutCome.errors
                    "
                  >
                    <span *ngIf="add.projectOutCome.errors.required"
                      >Project outcome is required</span
                    >
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-12 col-md-6 col-sm-12">
              <p class="sub-title">Organization Details</p>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12">
              <div class="form-rows">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    >Organization Name
                    <span class="text-danger">*</span></mat-label
                  >
                  <input
                    matInput
                    placeholder="Enter Organization Name "
                    formControlName="organizationName"
                    [ngClass]="{
                      'is-invalid':
                        add.organizationName.touched &&
                        add.organizationName.errors
                    }"
                  />
                  <mat-error
                    *ngIf="
                      add.organizationName.touched &&
                      add.organizationName.errors
                    "
                  >
                    <span *ngIf="add.organizationName.errors.required"
                      >Organization Name is required</span
                    >
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-6 col-12">
              <div class="form-rows">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    >Year of Incorporation<span class="text-danger"
                      >*</span
                    ></mat-label
                  >
                  <mat-select
                    formControlName="inCropYear"
                    [ngClass]="{
                      'is-invalid':
                        add.inCropYear.touched && add.inCropYear.errors
                    }"
                  >
                    <mat-option
                      *ngFor="let list of yearincorprateData"
                      [value]="list"
                    >
                      {{ list }}
                    </mat-option>
                  </mat-select>
                  <mat-error
                    *ngIf="add.inCropYear.touched && add.inCropYear.errors"
                  >
                    <span *ngIf="add.inCropYear.errors.required"
                      >Year of Incorporation is required</span
                    >
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12">
              <div class="form-rows">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label>Darpan Registration Number</mat-label>
                  <input
                    matInput
                    placeholder="Enter Darpan Registration Number "
                    formControlName="dropRegNo"
                    [ngClass]="{
                      'is-invalid':
                        add.dropRegNo.touched && add.dropRegNo.errors
                    }"
                  />
                  <mat-error
                    *ngIf="add.dropRegNo.touched && add.dropRegNo.errors"
                  >
                    <span *ngIf="add.dropRegNo.errors.required"
                      >Darpan Registration Number is required</span
                    >
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-8 col-md-6 col-sm-12">
              <div class="form-rows">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    >Registered address<span class="text-danger"
                      >*</span
                    ></mat-label
                  >
                  <textarea
                    matInput
                    formControlName="regAddr"
                    placeholder="Enter Register Address"
                    [ngClass]="{
                      'is-invalid': add.regAddr.touched && add.regAddr.errors
                    }"
                  ></textarea>
                  <mat-error *ngIf="add.regAddr.touched && add.regAddr.errors">
                    <span *ngIf="add.regAddr.errors.required"
                      >Registered address is required</span
                    >
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-12 col-md-6 col-sm-12">
              <p class="sub-title">CEO / Director Details</p>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12">
              <div class="form-rows">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    >Name of the CEO / Director
                    <span class="text-danger">*</span></mat-label
                  >
                  <input
                    matInput
                    placeholder="Enter Name"
                    formControlName="name"
                    [ngClass]="{
                      'is-invalid': add.name.touched && add.name.errors
                    }"
                  />
                  <mat-error *ngIf="add.name.touched && add.name.errors">
                    <span *ngIf="add.name.errors.required"
                      >Name is required</span
                    >
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12">
              <div class="form-rows">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    >Email ID <span class="text-danger">*</span></mat-label
                  >
                  <input
                    matInput
                    formControlName="email"
                    placeholder="Enter Email Id"
                    oninput="this.value = this.value.replace(/[^a-zA-Z0-9@.-+]/g,'')"
                    type="text"
                    (keydown.space)="$event.preventDefault()"
                    [ngClass]="{
                      'is-invalid': add.email.touched && add.email.errors
                    }"
                  />
                  <mat-error *ngIf="add.email.touched && add.email.errors">
                    <span *ngIf="add.email.errors.required"
                      >Email ID is required</span
                    >
                    <span *ngIf="add.email.errors.email">
                      <i class="fas fa-exclamation-triangle"></i>
                      Invalid Email
                    </span>
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12">
              <div class="form-rows">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    >Mobile <span class="text-danger">*</span></mat-label
                  >
                  <input
                    matInput
                    placeholder="Enter Mobile"
                    maxlength="10"
                    minlength="10"
                    formControlName="mobile"
                    oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                    [ngClass]="{
                      'is-invalid': add.mobile.touched && add.mobile.errors
                    }"
                  />
                  <mat-error *ngIf="add.mobile.touched && add.mobile.errors">
                    <span *ngIf="add.mobile.errors.required"
                      >Mobile Number is required</span
                    >
                    <span *ngIf="add.mobile.errors.pattern">
                      <i class="fas fa-exclamation-triangle"></i>
                      Mobile Number is Invalid
                    </span>
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="col-lg-12 col-md-6 col-sm-12">
              <p class="sub-title">SPOC Details</p>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12">
              <div class="form-rows">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    >SPOC Name<span class="text-danger">*</span></mat-label
                  >
                  <input
                    matInput
                    placeholder="Enter SPOC Name"
                    formControlName="spocName"
                    [ngClass]="{
                      'is-invalid': add.spocName.touched && add.spocName.errors
                    }"
                  />
                  <mat-error
                    *ngIf="add.spocName.touched && add.spocName.errors"
                  >
                    <span *ngIf="add.spocName.errors.required"
                      >SPOC Name is required</span
                    >
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12">
              <div class="form-rows">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    >SPOC Email ID <span class="text-danger">*</span></mat-label
                  >
                  <input
                    matInput
                    placeholder="Enter SPOC Email ID"
                    formControlName="spocEmail"
                    oninput="this.value = this.value.replace(/[^a-zA-Z0-9@.-+]/g,'')"
                    type="text"
                    (keydown.space)="$event.preventDefault()"
                    [ngClass]="{
                      'is-invalid':
                        add.spocEmail.touched && add.spocEmail.errors
                    }"
                  />
                  <mat-error
                    *ngIf="add.spocEmail.touched && add.spocEmail.errors"
                  >
                    <span *ngIf="add.spocEmail.errors.required"
                      >Email ID is required</span
                    >
                    <span *ngIf="add.spocEmail.errors.email">
                      <i class="fas fa-exclamation-triangle"></i>
                      Invalid Email
                    </span>
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12">
              <div class="form-rows">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    >SPOC Mobile<span class="text-danger">*</span></mat-label
                  >
                  <input
                    matInput
                    placeholder="Enter SPOC Mobile"
                    maxlength="10"
                    minlength="10"
                    oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                    placeholder="Enter Mobile Number"
                    formControlName="spocMobile"
                    [ngClass]="{
                      'is-invalid':
                        add.spocMobile.touched && add.spocMobile.errors
                    }"
                  />
                  <mat-error
                    *ngIf="add.spocMobile.touched && add.spocMobile.errors"
                  >
                    <span *ngIf="add.spocMobile.errors.required"
                      >Mobile Number is required</span
                    >
                    <span *ngIf="add.spocMobile.errors.pattern">
                      <i class="fas fa-exclamation-triangle"></i>
                      Mobile Number is Invalid
                    </span>
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="col-lg-12 col-md-6 col-sm-12">
              <p class="sub-title">Document Details</p>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12">
              <div class="form-rows mt-3">
                <mat-label
                  >Incorporation certificate
                  <span class="text-danger">*</span></mat-label
                >
                <label
                  *ngIf="RegdisName != '✔ Uploaded'"
                  for="input-file-id"
                  class="md-button md-raised md-primary"
                >
                  Choose File
                  <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                  <span class="ml-3">{{ RegdisName }}</span>
                  <input
                    class="d-none"
                    id="input-file-id"
                    type="file"
                    formControlName="incorpCertifDocuments"
                    (change)="fileRegUpload($event)"
                  />
                </label>
                <label
                  *ngIf="RegdisName == '✔ Uploaded'"
                  for="input-file-id"
                  class="md-button md-raised md-accent"
                >
                  Update File
                  <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                  <span class="ml-3">{{ RegdisName }}</span>
                  <input
                    class="d-none"
                    id="input-file-id"
                    type="file"
                    (change)="fileRegUpload($event)"
                  />
                </label>
                <span class="noti-span"
                  >(Supported Format: png,jpg,jpeg,pdf)
                  <span class="delete-span" *ngIf="RegdisName"
                    ><i
                      class="fas fa-trash delete-i"
                      (click)="deleteIncorporationImage()"
                      aria-hidden="true"
                    ></i></span
                  ><br />(max file size: 10mb)</span
                >
                <mat-error
                  class="font-12"
                  *ngIf="
                    add.incorpCertifDocuments.touched &&
                    add.incorpCertifDocuments.errors
                  "
                >
                  <span *ngIf="add.incorpCertifDocuments.errors.required"
                    >Document is required</span
                  >
                </mat-error>
                <div
                  class="text-center mt-2 mb-3"
                  *ngIf="RegdisName == '✔ Uploaded'"
                >
                  <a
                    class="pdf-btn"
                    href="{{ proFile.incorpCertifDocuments }}"
                    target="_blank"
                    >View Brochure</a
                  >
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12">
              <div class="form-rows mt-3">
                <mat-label
                  >12AA and 80G Certificate<span class="text-danger"
                    >*</span
                  ></mat-label
                >
                <label
                  *ngIf="TweldisName != '✔ Uploaded'"
                  for="input-file-ids"
                  class="md-button md-raised md-primary"
                >
                  Choose File
                  <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                  <span class="ml-3">{{ TweldisName }}</span>
                  <input
                    class="d-none"
                    id="input-file-ids"
                    type="file"
                    formControlName="twlaa80gDocuments"
                    (change)="twelldocfileUpload($event)"
                  />
                </label>
                <label
                  *ngIf="TweldisName == '✔ Uploaded'"
                  for="input-file-ids"
                  class="md-button md-raised md-accent"
                >
                  Update File
                  <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                  <span class="ml-3">{{ TweldisName }}</span>
                  <input
                    class="d-none"
                    id="input-file-ids"
                    type="file"
                    (change)="twelldocfileUpload($event)"
                  />
                </label>
                <span class="noti-span"
                  >(Supported Format: png,jpg,jpeg,pdf)
                  <span class="delete-span" *ngIf="TweldisName"
                    ><i
                      class="fas fa-trash delete-i"
                      (click)="deleteTwlaa80gImage()"
                      aria-hidden="true"
                    ></i></span
                  ><br />(max file size: 10mb)</span
                >
                <mat-error
                  class="font-12"
                  *ngIf="
                    add.twlaa80gDocuments.touched &&
                    add.twlaa80gDocuments.errors
                  "
                >
                  <span *ngIf="add.twlaa80gDocuments.errors.required"
                    >Document is required</span
                  >
                </mat-error>
                <div
                  class="text-center mt-2 mb-3"
                  *ngIf="TweldisName == '✔ Uploaded'"
                >
                  <a
                    class="pdf-btn"
                    href="{{ proFile.twlaa80gDocuments }}"
                    target="_blank"
                    >View Brochure</a
                  >
                </div>
              </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-12">
              <div class="form-rows mt-3">
                <mat-label
                  >Action plan of the project<span class="text-danger"
                    >*</span
                  ></mat-label
                >
                <label
                  *ngIf="ActiondisName != '✔ Uploaded'"
                  for="input-file-ids3"
                  class="md-button md-raised md-primary"
                >
                  Choose File
                  <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                  <span class="ml-3">{{ ActiondisName }}</span>
                  <input
                    class="d-none"
                    id="input-file-ids3"
                    type="file"
                    formControlName="actionPlanDocuments"
                    (change)="actiondocfileUpload($event)"
                  />
                </label>
                <label
                  *ngIf="ActiondisName == '✔ Uploaded'"
                  for="input-file-ids3"
                  class="md-button md-raised md-accent"
                >
                  Update File
                  <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                  <span class="ml-3">{{ ActiondisName }}</span>
                  <input
                    class="d-none"
                    id="input-file-ids3"
                    type="file"
                    (change)="actiondocfileUpload($event)"
                  />
                </label>
                <span class="noti-span"
                  >(Supported Format: png,jpg,jpeg,pdf)
                  <span class="delete-span" *ngIf="ActiondisName"
                    ><i
                      class="fas fa-trash delete-i"
                      (click)="deleteActionPlanImage()"
                      aria-hidden="true"
                    ></i></span
                  ><br />(max file size: 10mb)</span
                >
                <mat-error
                  class="font-12"
                  *ngIf="
                    add.actionPlanDocuments.touched &&
                    add.actionPlanDocuments.errors
                  "
                >
                  <span *ngIf="add.actionPlanDocuments.errors.required"
                    >Document is required</span
                  >
                </mat-error>
                <div
                  class="text-center mt-2 mb-3"
                  *ngIf="ActiondisName == '✔ Uploaded'"
                >
                  <a
                    class="pdf-btn"
                    href="{{ proFile.actionPlanDocuments }}"
                    target="_blank"
                    >View Brochure</a
                  >
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12">
              <div class="form-rows mt-3">
                <mat-label
                  >Track record of Incubator<span class="text-danger"></span
                ></mat-label>
                <label
                  *ngIf="TrackrecdisName != '✔ Uploaded'"
                  for="input-file-id4"
                  class="md-button md-raised md-primary"
                >
                  Choose File
                  <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                  <span class="ml-3">{{ TrackrecdisName }}</span>
                  <input
                    class="d-none"
                    id="input-file-id4"
                    type="file"
                    formControlName="trackRecordDocuments"
                    (change)="trackrecdocfileUpload($event)"
                  />
                </label>
                <label
                  *ngIf="TrackrecdisName == '✔ Uploaded'"
                  for="input-file-id4"
                  class="md-button md-raised md-accent"
                >
                  Update File
                  <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                  <span class="ml-3">{{ TrackrecdisName }}</span>
                  <input
                    class="d-none"
                    id="input-file-id4"
                    type="file"
                    (change)="trackrecdocfileUpload($event)"
                  />
                </label>
                <span class="noti-span"
                  >(Supported Format: png,jpg,jpeg,pdf)
                  <span class="delete-span" *ngIf="TrackrecdisName"
                    ><i
                      class="fas fa-trash delete-i"
                      (click)="deleteTrackRecordImage()"
                      aria-hidden="true"
                    ></i></span
                  ><br />(max file size: 10mb)</span
                >
                <mat-error
                  class="font-12"
                  *ngIf="
                    add.trackRecordDocuments.touched &&
                    add.trackRecordDocuments.errors
                  "
                >
                  <span *ngIf="add.trackRecordDocuments.errors.required"
                    >Document is required</span
                  >
                </mat-error>
                <div
                  class="text-center mt-2 mb-3"
                  *ngIf="TrackrecdisName == '✔ Uploaded'"
                >
                  <a
                    class="pdf-btn"
                    href="{{ proFile.trackRecordDocuments }}"
                    target="_blank"
                    >View Brochure</a
                  >
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12">
              <div class="form-rows mt-3">
                <mat-label
                  >Any other relevant document<span class="text-danger"></span
                ></mat-label>
                <label
                  *ngIf="OtherrecdisName != '✔ Uploaded'"
                  for="input-file-id5"
                  class="md-button md-raised md-primary"
                >
                  Choose File
                  <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                  <span class="ml-3">{{ OtherrecdisName }}</span>
                  <input
                    class="d-none"
                    id="input-file-id5"
                    type="file"
                    formControlName="otherDocuments"
                    (change)="otherrecdocfileUpload($event)"
                  />
                </label>
                <label
                  *ngIf="OtherrecdisName == '✔ Uploaded'"
                  for="input-file-id5"
                  class="md-button md-raised md-accent"
                >
                  Update File
                  <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
                  <span class="ml-3">{{ OtherrecdisName }}</span>
                  <input
                    class="d-none"
                    id="input-file-id5"
                    type="file"
                    (change)="otherrecdocfileUpload($event)"
                  />
                </label>
                <span class="noti-span"
                  >(Supported Format: png,jpg,jpeg,pdf)
                  <span class="delete-span" *ngIf="OtherrecdisName"
                    ><i
                      class="fas fa-trash delete-i"
                      (click)="deleteOtherImage()"
                      aria-hidden="true"
                    ></i></span
                  ><br />(max file size: 10mb)</span
                >
                <div
                  class="text-center mt-2 mb-3"
                  *ngIf="OtherrecdisName == '✔ Uploaded'"
                >
                  <a
                    class="pdf-btn"
                    href="{{ proFile.otherDocuments }}"
                    target="_blank"
                    >View Brochure</a
                  >
                </div>
              </div>
            </div>
            <div class="col-lg-12 col-md-3 col-sm-12 col-12">
              <div class="text-center form-btn mt-5">
                <button
                  class="update-btn btn new-btn-color"
                  (click)="saveProject()"
                >
                  Submit
                </button>
                <button
                  class="mr-2 btn new-btn-color2"
                  (click)="cancelProject()"
                >
                  Cancel</button
                ><br />
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</main>
